import styled from "styled-components";

export const CinemaContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
